import { has as _has } from 'lodash-es';

export function has<T>(target: T | null | undefined, property: keyof T): target is T {
	return _has(target, property);
}
